<template>
    <div>
        <div class="main-title">
            <v-container fill-height>
                <v-layout align-center>
                    {{ $t("register.title") }}
                </v-layout>
            </v-container>
        </div>
        <v-container class="lost-container">
            <v-layout>
                <v-flex>
                    <div>
                        {{ $t("register.tip") }}
                    </div>
                </v-flex>
            </v-layout>

            <v-form ref="form">
                <v-container>
                    <v-layout>
                        <v-flex xs12>
                            <v-text-field
                                v-model="email"
                                ref="email"
                                :rules="emailRules"
                                validate-on-blur
                                :label="$t('register.email_label')"
                                required
                                clearable
                            ></v-text-field>
                        </v-flex>
                        <!-- <v-flex xs3 @click="sendCode" v-if="!isGettingCode">
                          <v-layout align-center fill-height>
                            {{ $t("register.code-btn") }}
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-if="isGettingCode">
                          <v-layout align-center fill-height> {{ second }}s </v-layout>
                        </v-flex> -->
                    </v-layout>

<!--                    <v-layout :column="breakpoint.smAndDown">-->
<!--                        <v-flex xs6>-->
<!--                            <v-text-field-->
<!--                                ref="name"-->
<!--                                v-model="name"-->
<!--                                :rules="nameRules"-->
<!--                                validate-on-blur-->
<!--                                :label="$t('register.name')"-->
<!--                                required-->
<!--                                clearable-->
<!--                            ></v-text-field>-->
<!--                        </v-flex>-->
<!--                        <v-flex xs6>-->
<!--                            <v-text-field-->
<!--                                v-model="phone"-->
<!--                                ref="phone"-->
<!--                                :rules="phoneRules"-->
<!--                                validate-on-blur-->
<!--                                :label="$t('register.phone')"-->
<!--                                clearable-->
<!--                            ></v-text-field>-->
<!--                        </v-flex>-->
<!--                    </v-layout>-->
                    <v-layout :column="breakpoint.smAndDown">
                        <v-flex xs6>
                            <v-text-field
                                ref="comfrim_password"
                                v-model="comfrim_password"
                                :rules="nameRules"
                                validate-on-blur
                                :label="$t('register.pwd_label')"
                                required
                                :append-icon="showPassword1 ? 'visibility_off' : 'visibility'"
                                @click:append="showPassword1 = !showPassword1"
                                :type="showPassword1 ? 'text' : 'password'"
                                clearable
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs6>
                            <v-text-field
                                ref="password"
                                v-model="password"
                                :rules="nameRules"
                                validate-on-blur
                                :label="$t('register.confirm_pwd_label')"
                                required
                                :append-icon="showPassword2 ? 'visibility_off' : 'visibility'"
                                @click:append="showPassword2 = !showPassword2"
                                :type="showPassword2 ? 'text' : 'password'"
                                clearable
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>

            <v-layout column>
                <v-flex>
                    <button class="button shadow" @click="submit">
                        {{ $t("register.btn") }}
                    </button>
                </v-flex>
            </v-layout>
        </v-container>

        <v-dialog v-model="passwordTip" max-width="500px">
            <v-card>
                <v-card-title>
                    <span>{{ tip }}</span>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-actions v-if="!isRigisterSuccess">
                    <v-btn color="primary" flat @click="passwordTip = false">
                        {{ $t("common.close") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
const SECONDS = 6;

import account from "@/api/account";
import {mapMutations} from "vuex";

export default {
    data() {
        return {
            email: "",
            password: "",
            comfrim_password: "",
            name: "",
            phone: "",
            nameRules: [value => !!value || this.$t("login.rules")],
            emailRules: [
                value => !!value || this.$t("login.rules"),
                value =>
                    /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/.test(
                        value
                    ) || this.$t("common.email_rule")
            ],
            phoneRules: [
                value => !!value || this.$t("login.rules"),
                value => /^[679]\d{8}$/.test(value) || this.$t("common.phone_rule")
            ],
            showPassword1: false,
            showPassword2: false,
            isGettingCode: false,
            second: SECONDS,
            passwordTip: false,
            tip: this.$t("password.pwd_same"),
            isRigisterSuccess: false
        };
    },

    computed: {
        form() {
            return {
                email: this.email,
                password: this.password,
                comfrim_password: this.comfrim_password,
                // name: this.name
            };
        },
        breakpoint() {
            return this.$vuetify.breakpoint;
        }
    },

    methods: {
        ...mapMutations(["setGuid", "setTokenContent", "setUserInfo", "login"]),

        submit() {
            let isFull = true;
            Object.keys(this.form).forEach(f => {
                console.log(f);
                if (!this.form[f]) {
                    this.formHasErrors = true;
                    this.$refs[f].validate(true);
                    isFull = false;
                }
            });

            if (isFull) {
                if (this.password != this.comfrim_password) {
                    this.passwordTip = true;
                    return;
                }

                this.register();
            }
        },
        async register() {
            try {
                const res = await account.register({...this.form, phone: this.phone});

                if (!res.data.isError) {
                    // this.tip = res.data.data.prompt;
                    // this.passwordTip = true;
                    // this.isRigisterSuccess = true;
                    // setTimeout(() => {
                    //   this.$router.push({ name: "login" });
                    // }, 1500);

                    this.handleLogin();
                } else {
                    this.tip = res.data.msg;
                    this.passwordTip = true;
                }
            } catch (e) {
                this.tip = e.response.data.msg;
                this.passwordTip = true;
            }
        },

        async handleLogin() {
            try {
                const res = await account.login({
                    email: this.email,
                    password: this.password
                });

                if (!res.data.isError) {
                    this.login();
                    this.setGuid(res.data.data.guid);
                    this.setTokenContent(res.data.data.tokenContent);
                    const user_res = await account.loadCustomer();

                    if (!user_res.data.isError) {
                        this.setUserInfo(user_res.data.data);

                        setTimeout(() => {
                            this.$router.push({name: "home"});
                        }, 500);
                    }
                } else {
                    this.tip = res.data.msg;
                    this.passwordTip = true;
                }
            } catch (e) {
                this.tip = e.response.data.msg;
                this.passwordTip = true;
            }
        }

        // sendCode() {
        //   if (!this.form["email"]) {
        //     this.$refs["email"].validate(true);
        //     return;
        //   }

        //   this.isGettingCode = !this.isGettingCode;

        //   this.timer = setInterval(() => {
        //     this.second = this.second - 1;
        //     if (this.second < 1) {
        //       this.isGettingCode = !this.isGettingCode;
        //       this.second = SECONDS;
        //       clearInterval(this.timer);
        //     }
        //   }, 1000);
        // }
    }
};
</script>

<style scoped lang="sass" src="./register.sass"></style>
